var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$route.params.kravicka_id
    ? _c(
        "aside",
        {
          staticClass: "sideMenu position-fixed h-100",
          style: !_vm.sideMenu ? "" : "z-index:100;display:block"
        },
        [
          _c("router-link", { attrs: { to: "/" } }, [
            _c("img", {
              staticClass: "img-fluid header__logo",
              attrs: {
                src: "assets/img/adoptuj-kravicku-logo.svg",
                alt: "adoptuj-kravicku-logo"
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "sideMenu__close",
              attrs: {
                to: {
                  name: "kravicka",
                  params: { kravicka_id: _vm.$route.params.kravicka_id }
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c("ul", { staticClass: "m-sideMenu" }, [
            _c(
              "li",
              {
                staticClass: "a-sideMenu__item",
                on: { click: _vm.hideSideMenu }
              },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "obchod",
                        params: {
                          kategoria: "food",
                          kravicka_id: _vm.$route.params.kravicka_id
                        }
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon --jedlo" }),
                    _vm._v("Jedlo\n            ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "a-sideMenu__item",
                on: { click: _vm.hideSideMenu }
              },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "obchod",
                        params: {
                          kategoria: "drink",
                          kravicka_id: _vm.$route.params.kravicka_id
                        }
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon --pitie" }),
                    _vm._v("Pitie\n            ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "a-sideMenu__item",
                on: { click: _vm.hideSideMenu }
              },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "obchod",
                        params: {
                          kategoria: "cleanness",
                          kravicka_id: _vm.$route.params.kravicka_id
                        }
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon --cistota" }),
                    _vm._v("Čistota\n            ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "a-sideMenu__item",
                on: { click: _vm.hideSideMenu }
              },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "obchod",
                        params: {
                          kategoria: "background",
                          kravicka_id: _vm.$route.params.kravicka_id
                        }
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon --pozadia" }),
                    _vm._v("Pozadia\n            ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "a-sideMenu__item --spaceTop",
                on: { click: _vm.hideSideMenu }
              },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "zmenaren",
                        params: { kravicka_id: _vm.$route.params.kravicka_id }
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon --zmenaren" }),
                    _vm._v("Zmenáreň\n            ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "a-sideMenu__item --textLink" },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "kravicka",
                        params: { kravicka_id: _vm.$route.params.kravicka_id }
                      }
                    }
                  },
                  [
                    _vm._v("\n                Zavrieť obchod"),
                    _c("span", { staticClass: "icon --zavriet" })
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }